import React from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';
import { Form, Input as InputAntd } from 'antd';
import { DatePickerProps } from './types';
import { normalize } from './utils';
import './style.scss';

export const DatePicker: React.FC<DatePickerProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  const form = Form.useFormInstance();

  return (
    <div className={cn('form-item_date-picker', className)}>
      <Form.Item
        name={name}
        label={label}
        rules={rules}
        labelCol={{ span: 24 }}
        normalize={normalize}
        {...formItemProps}
      >
        <InputAntd
          inputMode="numeric"
          onBlur={(e) => {
            const input = e.target as HTMLInputElement;
            const { value } = input;
            if (value.length !== 10) return;
            const parsedDate = dayjs(value, 'MM/DD/YYYY', true);
            if (parsedDate.isValid()) {
              form.setFieldValue(name, parsedDate.format('MM/DD/YYYY'));
            }
          }}
          {...props}
        />
      </Form.Item>
    </div>
  );
};
